import React, { useState, useEffect } from "react";

const WaitingCell = React.memo(({ ts }) => {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => { setNow(Date.now()); }, 1000);
    return () => { clearInterval(interval) };
  }, []);

  if (!ts || isNaN(ts)) return 'Error';
  const diff = Math.max(0, now - ts);
  const hours = Math.floor((diff / (60 * 60 * 1000)) % 60).toString().padStart(2, '0');
  const minutes = Math.floor((diff / (60 * 1000)) % 60).toString().padStart(2, '0');
  const seconds = Math.floor((diff / 1000) % 60).toString().padStart(2, '0');

  return <>{`${minutes}:${seconds}`}</>;
});

export default WaitingCell;
